namespace TabAurous.Common {
    @Serenity.Decorators.registerEditor()
    export class IntegrationEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            // add option accepts a key (id) value and display text value
            this.addOption("Magento", "Magento");
            this.addOption("Amazon", "Amazon");
            this.addOption("Shopify", "Shopify");
            this.addOption("WooCommerce", "WooCommerce");
            this.addOption("RazorPay", "RazorPay");
        }
        protected get_items() {
            return this.options;
        }
    }
}